// @services/stubs/StubAccountClient.ts
import type { AccountClient } from '@services/clients/AccountClient';
import type { AccountError, AccountResponse } from "@ps-bridge/models/core/dataContracts";
import { makeEmail } from "@ps-bridge/models/brands/email";
import { makeFirstName } from "@ps-bridge/models/brands/firstName";
import { makeLastName } from "@ps-bridge/models/brands/lastName";
import { makeOrganizationName } from "@ps-bridge/models/brands/organizationName";
import { makeSubscriptionStatus } from "@ps-bridge/models/brands/subscriptionStatus";
import { makeIsoTimestamp } from "@ps-bridge/models/brands/isoTimestamp";
import * as Option from "@utils/Option";
import type { TaskEitherTs } from '@ps-bridge/interop';
import * as E from 'fp-ts/lib/Either';

import { ok } from "@ps-bridge/ok";
import type { Ok } from "@ps-bridge/ok";
import { taskEitherFromRaw } from '@utils/effects/branded';

const delay = (ms: number): Promise<Ok> =>
    new Promise((resolve) => setTimeout(() => resolve(ok), ms));

const delayedRight = <Error, Value>(ms: number, value: Value): TaskEitherTs<Error, Value> =>
    taskEitherFromRaw(async () => {
        await delay(ms);
        return E.right(value);
    });

export class StubAccountClient implements AccountClient {
    getAccountDetails: TaskEitherTs<AccountError, AccountResponse> = delayedRight(100, {
        email: makeEmail("bastion@ouroboros.ai"),
        status: makeSubscriptionStatus("Paid"),
        expiration: makeIsoTimestamp(new Date().toISOString()),
        firstName: Option.some(makeFirstName("Bastion")),
        lastName: Option.some(makeLastName("Ouroboros")),
        organizationName: Option.some(makeOrganizationName("Ouroboros")),
    });
}
